import { Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { AuthService } from './@core/authentication/services/auth.service';
import { InactivitySessionManagerService } from './@core/authentication/services/inactivity-session-manager.service';
import { SessionTimeoutModalComponent } from './@core/authentication/session-timeout-modal/session-timeout-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SessionTimeoutModalComponent],
  template: `
    <router-outlet />
    <app-session-timeout-modal />
  `,
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly inactivitySession = inject(InactivitySessionManagerService);

  private sessionStarted = false;

  constructor() {
    effect(() => {
      const isAuth = this.authService.isAuthenticated();

      if (isAuth && !this.sessionStarted) {
        this.inactivitySession.start();
        this.sessionStarted = true;
      } else if (!isAuth && this.sessionStarted) {
        this.inactivitySession.stop();
        this.sessionStarted = false;
      }
    });
  }

  ngOnInit(): void {
    this.authService.initAuthState();
    initFlowbite();
  }
}
